import Axios from 'axios'
import config from '../app.config'

export var mailBoxService
export default mailBoxService = {
	getMasterData
}

async function getMasterData(params, type = 0) {
	return await Axios.get(`${config.LOCAL_API_URL}/getMailBoxMasterData/${type}`,{ params: params })
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
